import React from "react";
import PopupBodyItem from "../../../Helpers/Popup/PopupParts/PopupBodyItem";

const CategoryPopupBody = ({ data }) => {
  return (
    <div>
      <div>
        <div className="display-border">
          <PopupBodyItem title="Category Code" item={data?.code || "-----"} />
          <PopupBodyItem
            title="# Sub-categories"
            item={
              typeof data?._count?.subcategory === "number"
                ? data._count.subcategory
                : "-----"
            }
          />
          <PopupBodyItem
            title="Description"
            item={data?.description || "------"}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryPopupBody;
